// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OJ-z","twoColumnImage":"PJ-z"};